import React from "react";
import Config from "../config.json";

function SiteMap() {
  function renderList() {
    return (

          <ul className="list-unstyled" aria-labelledby="sitemap">
            <li>
              <a href={process.env.PUBLIC_URL}>Home</a>
            </li>
            {Config.storage.folders
              .filter((f) => f.hidden !== true)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((folder, i) => (
                <li>
                  <a href={process.env.PUBLIC_URL + folder.routePath}>
                    {folder.title}
                  </a>
                </li>
              ))}
          </ul>
  
    );
  }

  return (
    <main id="main-content" className="main mt-3">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h1 id="sitemap">Site Map</h1>
            {renderList()}
          </div>
        </div>
      </div>
    </main>
  );
}

export default SiteMap;
